/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type Artifact = {
  __typename?: 'Artifact';
  createTime?: Maybe<Scalars['String']['output']>;
  dependencies?: Maybe<Array<Maybe<ArtifactDependency>>>;
  downloadable?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastRelease?: Maybe<Release>;
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  semver?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
  uploadTime?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ArtifactDependency = {
  __typename?: 'ArtifactDependency';
  semver?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export type ArtifactInput = {
  semver: Scalars['String']['input'];
  typeName: Scalars['String']['input'];
};

export type ArtifactType = {
  __typename?: 'ArtifactType';
  compatibleDevices?: Maybe<Array<Maybe<DeviceTypeName>>>;
  fileExtension?: Maybe<Scalars['String']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export type ArtifactTypeList = {
  __typename?: 'ArtifactTypeList';
  types?: Maybe<Array<Maybe<ArtifactType>>>;
};

export type AssociateTagWithDeviceInput = {
  serialNumber: Scalars['String']['input'];
  tagId: Scalars['ID']['input'];
  tagName?: InputMaybe<Scalars['String']['input']>;
};

export type AssociateTagWithDeviceResponse = {
  __typename?: 'AssociateTagWithDeviceResponse';
  deviceTag?: Maybe<DeviceTag>;
};

export type CancelIotJobExecutionInput = {
  canopyDeviceId: Scalars['ID']['input'];
  jobId: Scalars['String']['input'];
};

export type CreateTagInput = {
  tagName: Scalars['String']['input'];
};

export type CreateTagResponse = {
  __typename?: 'CreateTagResponse';
  tag?: Maybe<Tag>;
};

export type DeleteTagInput = {
  tagId: Scalars['ID']['input'];
};

export type DeleteTagResponse = {
  __typename?: 'DeleteTagResponse';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeletionResult = {
  __typename?: 'DeletionResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeployToDeviceInput = {
  canopyDeviceId: Scalars['String']['input'];
  deploymentId: Scalars['ID']['input'];
  serialNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Deployment = {
  __typename?: 'Deployment';
  attempts?: Maybe<Array<Maybe<DeploymentAttempt>>>;
  consoleJobUrl?: Maybe<Scalars['String']['output']>;
  createTime?: Maybe<Scalars['String']['output']>;
  deploymentGroup?: Maybe<Scalars['String']['output']>;
  forceInstall?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  lastDeployedBy?: Maybe<Scalars['String']['output']>;
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  release?: Maybe<Release>;
  status?: Maybe<DeploymentStatus>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type DeploymentAttempt = {
  __typename?: 'DeploymentAttempt';
  deployedBy?: Maybe<Scalars['String']['output']>;
  forceInstall?: Maybe<Scalars['Boolean']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DeploymentInfoByDevice = {
  __typename?: 'DeploymentInfoByDevice';
  batteryLevel?: Maybe<Scalars['Int']['output']>;
  canopyDeviceId: Scalars['String']['output'];
  deployments?: Maybe<Array<DeviceDeployment>>;
  deviceReportedVersion?: Maybe<Scalars['String']['output']>;
  lastConnected?: Maybe<Scalars['String']['output']>;
  lifecycleState: Scalars['String']['output'];
  pendingOta?: Maybe<PendingOtaState>;
  vehicle?: Maybe<VimState>;
};

export type DeploymentInput = {
  forceInstall?: InputMaybe<Scalars['Boolean']['input']>;
  releaseId: Scalars['String']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum DeploymentStatus {
  ACTIVE = 'active',
  CREATED = 'created',
  INACTIVE = 'inactive',
  STRATOSPHERE = 'stratosphere',
}

export type DeviceDeployment = {
  __typename?: 'DeviceDeployment';
  canopyDeviceId: Scalars['String']['output'];
  deploymentId: Scalars['ID']['output'];
  downloadStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  installStatus?: Maybe<Scalars['String']['output']>;
  jobId?: Maybe<Scalars['String']['output']>;
  serialNumber: Scalars['String']['output'];
  states?: Maybe<DeviceDeploymentStates>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type DeviceDeploymentStates = {
  __typename?: 'DeviceDeploymentStates';
  download?: Maybe<Array<Maybe<DeviceDeploymentStatusEntry>>>;
  install?: Maybe<Array<Maybe<DeviceDeploymentStatusEntry>>>;
};

export type DeviceDeploymentStatusEntry = {
  __typename?: 'DeviceDeploymentStatusEntry';
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type DeviceTag = {
  __typename?: 'DeviceTag';
  canopyDeviceId?: Maybe<Scalars['ID']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['ID']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
};

export type DeviceType = {
  __typename?: 'DeviceType';
  typeName?: Maybe<DeviceTypeName>;
};

export type DeviceTypeList = {
  __typename?: 'DeviceTypeList';
  types?: Maybe<Array<Maybe<DeviceType>>>;
};

export enum DeviceTypeName {
  TRUCK = 'truck',
  VAN = 'van',
}

export type DisassociateTagFromDeviceInput = {
  serialNumber: Scalars['String']['input'];
  tagId: Scalars['ID']['input'];
};

export type DisassociateTagFromDeviceResponse = {
  __typename?: 'DisassociateTagFromDeviceResponse';
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type GetDeviceTagsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  next?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetDeviceTagsResponse = {
  __typename?: 'GetDeviceTagsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<DeviceTag>>>;
};

export type GetSqlInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GetTagByNameResponse = {
  __typename?: 'GetTagByNameResponse';
  tagId: Scalars['ID']['output'];
  tagName: Scalars['String']['output'];
};

export type GetTagsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  next?: InputMaybe<Scalars['String']['input']>;
};

export type GetTagsResponse = {
  __typename?: 'GetTagsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<Tag>>>;
};

export type GroupedArtifactEntry = {
  __typename?: 'GroupedArtifactEntry';
  artifacts?: Maybe<Array<Maybe<Artifact>>>;
  typeName?: Maybe<Scalars['String']['output']>;
};

export type GroupedArtifacts = {
  __typename?: 'GroupedArtifacts';
  groups?: Maybe<Array<Maybe<GroupedArtifactEntry>>>;
};

export enum IotJobExecStatus {
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  QUEUED = 'QUEUED',
  REJECTED = 'REJECTED',
  REMOVED = 'REMOVED',
  SUCCEEDED = 'SUCCEEDED',
}

export type IotJobStatusInput = {
  canopyDeviceId: Scalars['ID']['input'];
  jobId: Scalars['String']['input'];
};

export type IotJobStatusResponse = {
  __typename?: 'IotJobStatusResponse';
  isCancellable: Scalars['Boolean']['output'];
  lastUpdatedAt: Scalars['String']['output'];
  status: IotJobExecStatus;
};

export type Mutation = {
  __typename?: 'Mutation';
  associateTagWithDevice?: Maybe<AssociateTagWithDeviceResponse>;
  cancelIotJobExecution?: Maybe<Scalars['String']['output']>;
  createArtifact: Artifact;
  createDeployment?: Maybe<Deployment>;
  createRelease: Release;
  createSQL?: Maybe<Scalars['Boolean']['output']>;
  createTag?: Maybe<CreateTagResponse>;
  deleteRelease: DeletionResult;
  deleteTag?: Maybe<DeleteTagResponse>;
  deployToDevice?: Maybe<Scalars['String']['output']>;
  disassociateTagFromDevice?: Maybe<DisassociateTagFromDeviceResponse>;
  sendStartInstallToDevice?: Maybe<Scalars['String']['output']>;
  updateTag?: Maybe<UpdateTagResponse>;
};

export type MutationAssociateTagWithDeviceArgs = {
  input: AssociateTagWithDeviceInput;
};

export type MutationCancelIotJobExecutionArgs = {
  input: CancelIotJobExecutionInput;
};

export type MutationCreateArtifactArgs = {
  artifact: ArtifactInput;
};

export type MutationCreateDeploymentArgs = {
  deployment: DeploymentInput;
};

export type MutationCreateReleaseArgs = {
  release: ReleaseInput;
};

export type MutationCreateTagArgs = {
  input: CreateTagInput;
};

export type MutationDeleteReleaseArgs = {
  releaseId: Scalars['ID']['input'];
};

export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};

export type MutationDeployToDeviceArgs = {
  input: DeployToDeviceInput;
};

export type MutationDisassociateTagFromDeviceArgs = {
  input: DisassociateTagFromDeviceInput;
};

export type MutationSendStartInstallToDeviceArgs = {
  input: SendStartInstallToDeviceInput;
};

export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};

export type PaginatedArtifactList = {
  __typename?: 'PaginatedArtifactList';
  items?: Maybe<Array<Maybe<Artifact>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedDeploymentList = {
  __typename?: 'PaginatedDeploymentList';
  items?: Maybe<Array<Maybe<Deployment>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedDeviceDeploymentList = {
  __typename?: 'PaginatedDeviceDeploymentList';
  items?: Maybe<Array<Maybe<DeviceDeployment>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PaginatedReleaseList = {
  __typename?: 'PaginatedReleaseList';
  items?: Maybe<Array<Maybe<Release>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type PendingOtaState = {
  __typename?: 'PendingOtaState';
  status?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  getArtifact?: Maybe<Artifact>;
  getArtifactTypes: ArtifactTypeList;
  getArtifacts?: Maybe<PaginatedArtifactList>;
  getDeployment?: Maybe<Deployment>;
  getDeploymentInfoByDevice?: Maybe<DeploymentInfoByDevice>;
  getDeployments?: Maybe<PaginatedDeploymentList>;
  getDeviceDeployments?: Maybe<PaginatedDeviceDeploymentList>;
  getDeviceTags?: Maybe<GetDeviceTagsResponse>;
  getDeviceTypes: DeviceTypeList;
  getFieldDevicesTag?: Maybe<GetTagByNameResponse>;
  getGroupedArtifacts?: Maybe<GroupedArtifacts>;
  getIotJobStatus?: Maybe<IotJobStatusResponse>;
  getLatestDeployment?: Maybe<Deployment>;
  getRelease?: Maybe<Release>;
  getSQL?: Maybe<Array<Maybe<Sql>>>;
  getTagByName?: Maybe<GetTagByNameResponse>;
  getTags?: Maybe<GetTagsResponse>;
};

export type QueryGetArtifactArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetArtifactsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  typeName: Scalars['String']['input'];
};

export type QueryGetDeploymentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetDeploymentInfoByDeviceArgs = {
  serialNumber: Scalars['String']['input'];
};

export type QueryGetDeploymentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  status: DeploymentStatus;
};

export type QueryGetDeviceDeploymentsArgs = {
  deploymentId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetDeviceTagsArgs = {
  input: GetDeviceTagsInput;
};

export type QueryGetGroupedArtifactsArgs = {
  deviceType?: InputMaybe<DeviceTypeName>;
};

export type QueryGetIotJobStatusArgs = {
  input: IotJobStatusInput;
};

export type QueryGetReleaseArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetSqlArgs = {
  input: GetSqlInput;
};

export type QueryGetTagByNameArgs = {
  tagName: Scalars['String']['input'];
};

export type QueryGetTagsArgs = {
  input: GetTagsInput;
};

export type Release = {
  __typename?: 'Release';
  artifacts?: Maybe<Array<Maybe<Artifact>>>;
  createTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<DeviceTypeName>;
  id?: Maybe<Scalars['ID']['output']>;
  isDeployed?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  isStable?: Maybe<Scalars['Boolean']['output']>;
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  releaseNotes?: Maybe<Scalars['String']['output']>;
  semver?: Maybe<Scalars['String']['output']>;
};

export type ReleaseInput = {
  artifactIds: Array<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  deviceType: DeviceTypeName;
  releaseNotes?: InputMaybe<Scalars['String']['input']>;
  semver: Scalars['String']['input'];
};

export type Sql = {
  __typename?: 'SQL';
  childId?: Maybe<Scalars['String']['output']>;
  otherId?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
};

export type SendStartInstallToDeviceInput = {
  canopyDeviceId: Scalars['ID']['input'];
  jobId: Scalars['String']['input'];
};

export type Tag = {
  __typename?: 'Tag';
  tagId?: Maybe<Scalars['ID']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
};

export type UpdateTagInput = {
  tagId: Scalars['ID']['input'];
  tagName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTagResponse = {
  __typename?: 'UpdateTagResponse';
  tag?: Maybe<Tag>;
};

export type VimState = {
  __typename?: 'VIMState';
  isInMotion?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type CreateDeploymentMutationVariables = Exact<{
  deployment: DeploymentInput;
}>;

export type CreateDeploymentMutation = {
  __typename?: 'Mutation';
  createDeployment?: {
    __typename?: 'Deployment';
    id?: string | null;
    jobId?: string | null;
  } | null;
};

export type CreateReleaseMutationVariables = Exact<{
  release: ReleaseInput;
}>;

export type CreateReleaseMutation = {
  __typename?: 'Mutation';
  createRelease: { __typename?: 'Release'; id?: string | null };
};

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;

export type CreateTagMutation = {
  __typename?: 'Mutation';
  createTag?: {
    __typename?: 'CreateTagResponse';
    tag?: {
      __typename?: 'Tag';
      tagId?: string | null;
      tagName?: string | null;
    } | null;
  } | null;
};

export type UpdateTagMutationVariables = Exact<{
  input: UpdateTagInput;
}>;

export type UpdateTagMutation = {
  __typename?: 'Mutation';
  updateTag?: {
    __typename?: 'UpdateTagResponse';
    tag?: {
      __typename?: 'Tag';
      tagId?: string | null;
      tagName?: string | null;
    } | null;
  } | null;
};

export type GetDeviceTagsQueryVariables = Exact<{
  input: GetDeviceTagsInput;
}>;

export type GetDeviceTagsQuery = {
  __typename?: 'Query';
  getDeviceTags?: {
    __typename?: 'GetDeviceTagsResponse';
    count?: number | null;
    next?: string | null;
    prev?: string | null;
    results?: Array<{
      __typename?: 'DeviceTag';
      tagId?: string | null;
      canopyDeviceId?: string | null;
      serialNumber?: string | null;
      tagName?: string | null;
    } | null> | null;
  } | null;
};

export type AssociateTagWithDeviceMutationVariables = Exact<{
  input: AssociateTagWithDeviceInput;
}>;

export type AssociateTagWithDeviceMutation = {
  __typename?: 'Mutation';
  associateTagWithDevice?: {
    __typename?: 'AssociateTagWithDeviceResponse';
    deviceTag?: {
      __typename?: 'DeviceTag';
      tagId?: string | null;
      canopyDeviceId?: string | null;
      serialNumber?: string | null;
      tagName?: string | null;
    } | null;
  } | null;
};

export type DisassociateTagFromDeviceMutationVariables = Exact<{
  input: DisassociateTagFromDeviceInput;
}>;

export type DisassociateTagFromDeviceMutation = {
  __typename?: 'Mutation';
  disassociateTagFromDevice?: {
    __typename?: 'DisassociateTagFromDeviceResponse';
    ok?: boolean | null;
  } | null;
};

export type GetTagByNameQueryVariables = Exact<{
  tagName: Scalars['String']['input'];
}>;

export type GetTagByNameQuery = {
  __typename?: 'Query';
  getTagByName?: {
    __typename?: 'GetTagByNameResponse';
    tagId: string;
    tagName: string;
  } | null;
};
export type GetGroupedArtifactsQueryVariables = Exact<{
  deviceTypeName?: InputMaybe<DeviceTypeName>;
}>;

export type GetGroupedArtifactsQuery = {
  __typename?: 'Query';
  getGroupedArtifacts?: {
    __typename?: 'GroupedArtifacts';
    groups?: Array<{
      __typename?: 'GroupedArtifactEntry';
      typeName?: string | null;
      artifacts?: Array<{
        __typename?: 'Artifact';
        id?: string | null;
        semver?: string | null;
        typeName?: string | null;
        lastUpdateTime?: string | null;
        createTime?: string | null;
        lastRelease?: { __typename?: 'Release'; semver?: string | null } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export const CreateDeploymentDocument = gql`
  mutation CreateDeployment($deployment: DeploymentInput!) {
    createDeployment(deployment: $deployment) {
      id
      jobId
    }
  }
`;
export type CreateDeploymentMutationFn = Apollo.MutationFunction<
  CreateDeploymentMutation,
  CreateDeploymentMutationVariables
>;

/**
 * __useCreateDeploymentMutation__
 *
 * To run a mutation, you first call `useCreateDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeploymentMutation, { data, loading, error }] = useCreateDeploymentMutation({
 *   variables: {
 *      deployment: // value for 'deployment'
 *   },
 * });
 */
export function useCreateDeploymentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDeploymentMutation,
    CreateDeploymentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDeploymentMutation,
    CreateDeploymentMutationVariables
  >(CreateDeploymentDocument, options);
}
export type CreateDeploymentMutationHookResult = ReturnType<
  typeof useCreateDeploymentMutation
>;
export type CreateDeploymentMutationResult =
  Apollo.MutationResult<CreateDeploymentMutation>;
export type CreateDeploymentMutationOptions = Apollo.BaseMutationOptions<
  CreateDeploymentMutation,
  CreateDeploymentMutationVariables
>;
export const CreateReleaseDocument = gql`
  mutation CreateRelease($release: ReleaseInput!) {
    createRelease(release: $release) {
      id
    }
  }
`;
export type CreateReleaseMutationFn = Apollo.MutationFunction<
  CreateReleaseMutation,
  CreateReleaseMutationVariables
>;

/**
 * __useCreateReleaseMutation__
 *
 * To run a mutation, you first call `useCreateReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReleaseMutation, { data, loading, error }] = useCreateReleaseMutation({
 *   variables: {
 *      release: // value for 'release'
 *   },
 * });
 */
export function useCreateReleaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateReleaseMutation,
    CreateReleaseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateReleaseMutation,
    CreateReleaseMutationVariables
  >(CreateReleaseDocument, options);
}
export type CreateReleaseMutationHookResult = ReturnType<
  typeof useCreateReleaseMutation
>;
export type CreateReleaseMutationResult =
  Apollo.MutationResult<CreateReleaseMutation>;
export type CreateReleaseMutationOptions = Apollo.BaseMutationOptions<
  CreateReleaseMutation,
  CreateReleaseMutationVariables
>;
export const CreateTagDocument = gql`
  mutation CreateTag($input: CreateTagInput!) {
    createTag(input: $input) {
      tag {
        tagId
        tagName
      }
    }
  }
`;
export type CreateTagMutationFn = Apollo.MutationFunction<
  CreateTagMutation,
  CreateTagMutationVariables
>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTagMutation,
    CreateTagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(
    CreateTagDocument,
    options,
  );
}
export type CreateTagMutationHookResult = ReturnType<
  typeof useCreateTagMutation
>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<
  CreateTagMutation,
  CreateTagMutationVariables
>;
export const UpdateTagDocument = gql`
  mutation UpdateTag($input: UpdateTagInput!) {
    updateTag(input: $input) {
      tag {
        tagId
        tagName
      }
    }
  }
`;
export type UpdateTagMutationFn = Apollo.MutationFunction<
  UpdateTagMutation,
  UpdateTagMutationVariables
>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTagMutation,
    UpdateTagMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(
    UpdateTagDocument,
    options,
  );
}
export type UpdateTagMutationHookResult = ReturnType<
  typeof useUpdateTagMutation
>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<
  UpdateTagMutation,
  UpdateTagMutationVariables
>;

export const GetDeviceTagsDocument = gql`
  query GetDeviceTags($input: GetDeviceTagsInput!) {
    getDeviceTags(input: $input) {
      results {
        tagId
        canopyDeviceId
        serialNumber
        tagName
      }
      count
      next
      prev
    }
  }
`;

/**
 * __useGetDeviceTagsQuery__
 *
 * To run a query within a React component, call `useGetDeviceTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeviceTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeviceTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDeviceTagsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDeviceTagsQuery,
    GetDeviceTagsQueryVariables
  > &
    (
      | { variables: GetDeviceTagsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDeviceTagsQuery, GetDeviceTagsQueryVariables>(
    GetDeviceTagsDocument,
    options,
  );
}
export function useGetDeviceTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDeviceTagsQuery,
    GetDeviceTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDeviceTagsQuery, GetDeviceTagsQueryVariables>(
    GetDeviceTagsDocument,
    options,
  );
}
export function useGetDeviceTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDeviceTagsQuery,
    GetDeviceTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDeviceTagsQuery,
    GetDeviceTagsQueryVariables
  >(GetDeviceTagsDocument, options);
}
export type GetDeviceTagsQueryHookResult = ReturnType<
  typeof useGetDeviceTagsQuery
>;
export type GetDeviceTagsLazyQueryHookResult = ReturnType<
  typeof useGetDeviceTagsLazyQuery
>;
export type GetDeviceTagsSuspenseQueryHookResult = ReturnType<
  typeof useGetDeviceTagsSuspenseQuery
>;
export type GetDeviceTagsQueryResult = Apollo.QueryResult<
  GetDeviceTagsQuery,
  GetDeviceTagsQueryVariables
>;
export const AssociateTagWithDeviceDocument = gql`
  mutation AssociateTagWithDevice($input: AssociateTagWithDeviceInput!) {
    associateTagWithDevice(input: $input) {
      deviceTag {
        tagId
        canopyDeviceId
        serialNumber
        tagName
      }
    }
  }
`;
export type AssociateTagWithDeviceMutationFn = Apollo.MutationFunction<
  AssociateTagWithDeviceMutation,
  AssociateTagWithDeviceMutationVariables
>;

/**
 * __useAssociateTagWithDeviceMutation__
 *
 * To run a mutation, you first call `useAssociateTagWithDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateTagWithDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateTagWithDeviceMutation, { data, loading, error }] = useAssociateTagWithDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssociateTagWithDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssociateTagWithDeviceMutation,
    AssociateTagWithDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssociateTagWithDeviceMutation,
    AssociateTagWithDeviceMutationVariables
  >(AssociateTagWithDeviceDocument, options);
}
export type AssociateTagWithDeviceMutationHookResult = ReturnType<
  typeof useAssociateTagWithDeviceMutation
>;
export type AssociateTagWithDeviceMutationResult =
  Apollo.MutationResult<AssociateTagWithDeviceMutation>;
export type AssociateTagWithDeviceMutationOptions = Apollo.BaseMutationOptions<
  AssociateTagWithDeviceMutation,
  AssociateTagWithDeviceMutationVariables
>;
export const DisassociateTagFromDeviceDocument = gql`
  mutation DisassociateTagFromDevice($input: DisassociateTagFromDeviceInput!) {
    disassociateTagFromDevice(input: $input) {
      ok
    }
  }
`;
export type DisassociateTagFromDeviceMutationFn = Apollo.MutationFunction<
  DisassociateTagFromDeviceMutation,
  DisassociateTagFromDeviceMutationVariables
>;

/**
 * __useDisassociateTagFromDeviceMutation__
 *
 * To run a mutation, you first call `useDisassociateTagFromDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisassociateTagFromDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disassociateTagFromDeviceMutation, { data, loading, error }] = useDisassociateTagFromDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisassociateTagFromDeviceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisassociateTagFromDeviceMutation,
    DisassociateTagFromDeviceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisassociateTagFromDeviceMutation,
    DisassociateTagFromDeviceMutationVariables
  >(DisassociateTagFromDeviceDocument, options);
}
export type DisassociateTagFromDeviceMutationHookResult = ReturnType<
  typeof useDisassociateTagFromDeviceMutation
>;
export type DisassociateTagFromDeviceMutationResult =
  Apollo.MutationResult<DisassociateTagFromDeviceMutation>;
export type DisassociateTagFromDeviceMutationOptions =
  Apollo.BaseMutationOptions<
    DisassociateTagFromDeviceMutation,
    DisassociateTagFromDeviceMutationVariables
  >;
export const GetTagByNameDocument = gql`
  query GetTagByName($tagName: String!) {
    getTagByName(tagName: $tagName) {
      tagId
      tagName
    }
  }
`;

/**
 * __useGetTagByNameQuery__
 *
 * To run a query within a React component, call `useGetTagByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTagByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTagByNameQuery({
 *   variables: {
 *      tagName: // value for 'tagName'
 *   },
 * });
 */
export function useGetTagByNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTagByNameQuery,
    GetTagByNameQueryVariables
  > &
    (
      | { variables: GetTagByNameQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTagByNameQuery, GetTagByNameQueryVariables>(
    GetTagByNameDocument,
    options,
  );
}
export function useGetTagByNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTagByNameQuery,
    GetTagByNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTagByNameQuery, GetTagByNameQueryVariables>(
    GetTagByNameDocument,
    options,
  );
}
export function useGetTagByNameSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetTagByNameQuery,
    GetTagByNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetTagByNameQuery, GetTagByNameQueryVariables>(
    GetTagByNameDocument,
    options,
  );
}
export type GetTagByNameQueryHookResult = ReturnType<
  typeof useGetTagByNameQuery
>;
export type GetTagByNameLazyQueryHookResult = ReturnType<
  typeof useGetTagByNameLazyQuery
>;
export type GetTagByNameSuspenseQueryHookResult = ReturnType<
  typeof useGetTagByNameSuspenseQuery
>;
export type GetTagByNameQueryResult = Apollo.QueryResult<
  GetTagByNameQuery,
  GetTagByNameQueryVariables
>;

export const GetGroupedArtifactsDocument = gql`
  query GetGroupedArtifacts($deviceTypeName: DeviceTypeName) {
    getGroupedArtifacts(deviceType: $deviceTypeName) {
      groups {
        typeName
        artifacts {
          id
          semver
          typeName
          lastUpdateTime
          createTime
          lastRelease {
            semver
          }
        }
      }
    }
  }
`;

/**
 * __useGetGroupedArtifactsQuery__
 *
 * To run a query within a React component, call `useGetGroupedArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupedArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupedArtifactsQuery({
 *   variables: {
 *      deviceTypeName: // value for 'deviceTypeName'
 *   },
 * });
 */
export function useGetGroupedArtifactsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetGroupedArtifactsQuery,
    GetGroupedArtifactsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetGroupedArtifactsQuery,
    GetGroupedArtifactsQueryVariables
  >(GetGroupedArtifactsDocument, options);
}
export function useGetGroupedArtifactsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupedArtifactsQuery,
    GetGroupedArtifactsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetGroupedArtifactsQuery,
    GetGroupedArtifactsQueryVariables
  >(GetGroupedArtifactsDocument, options);
}
export function useGetGroupedArtifactsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetGroupedArtifactsQuery,
    GetGroupedArtifactsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetGroupedArtifactsQuery,
    GetGroupedArtifactsQueryVariables
  >(GetGroupedArtifactsDocument, options);
}
export type GetGroupedArtifactsQueryHookResult = ReturnType<
  typeof useGetGroupedArtifactsQuery
>;
export type GetGroupedArtifactsLazyQueryHookResult = ReturnType<
  typeof useGetGroupedArtifactsLazyQuery
>;
export type GetGroupedArtifactsSuspenseQueryHookResult = ReturnType<
  typeof useGetGroupedArtifactsSuspenseQuery
>;
export type GetGroupedArtifactsQueryResult = Apollo.QueryResult<
  GetGroupedArtifactsQuery,
  GetGroupedArtifactsQueryVariables
>;
